module.exports = __webpack_public_path__ + "media/club_deals/current_opportunities_vertical_card3-3e88b31b.webp";